import React, { useEffect } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from 'sonner';
import CursorTrail from './components/CursorTrail';

import LandingPage from './pages/LandingPage';
import AdminLogin from './pages/AdminLogin';
import AdminAuthCallback from './pages/AdminAuthCallback';
import AdminDashboard from './pages/AdminDashboard';
import AdminDetail from './pages/AdminDetail';
import ClienteWizard from './pages/ClienteWizard';
import ClienteSuccess from './pages/ClienteSuccess';
import ClienteVerification from './pages/ClienteVerification';

function AppRouter() {
  const location = useLocation();
  // Check for session_id in hash - process before normal routing
  if (location.hash?.includes('session_id=')) {
    return <AdminAuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/auth/callback" element={<AdminAuthCallback />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin/beneficiario/:cedula" element={<AdminDetail />} />
      <Route path="/cliente/:cedula" element={<ClienteWizard />} />
      <Route path="/cliente/:cedula/verification" element={<ClienteVerification />} />
      <Route path="/cliente/:cedula/success" element={<ClienteSuccess />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = 'La Meta - KOMPA';
  }, []);

  return (
    <div className="App">
      <CursorTrail />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
